import Form from '@appComponents/ReduxFormControls';
import {SRT_ORIGIN_ENTRY_POINT} from '@constants/resources';
import { BASE_FORM_MESSAGES } from '@constants/messages';
import {adSpliceConfigField, adSupportSCTEField} from '@modules/adSplice/form/fieldsModel';
import {
    CreateSrtOriginEntryPoint,
    DeleteSrtOriginEntryPoint,
    UpdateSrtOriginEntryPoint,
} from '@graphql/srtOriginEntryPoints/mutation';
import {GetSrtOriginEntryPointForForm, GetOptionsForForm} from '@graphql/srtOriginEntryPoints/query';
import {REQUIRE_THREE_LETTERS_PLACEHOLDER} from '@constants/variables';

import {renderFormErrorMessages} from '../utils/helpers';
import validate from './validator';

export default function SrtOriginEntryPointModel() {
    return {
        entityDataMapKey: 'srtOriginEntryPoint',
        entityLabel: 'SRT origin entry point',
        formName: 'srtOriginEntryPoint',
        label: 'SrtOriginEntryPoint',
        resources: SRT_ORIGIN_ENTRY_POINT,
        showChangelog: true,
        validate: validate,
        title: null,
        dataMap: {
            srtOriginEntryPoint: {
                id: '',
                name: '',
                description: '',
                url: '',
                previewUrl: null,
                closeCaptioning: false,
                adSupport: false,
                adSpliceConfig: '',
                tournaments: [],
                contentCategories: [],
            },
        },
        messages: {
            boxName: {
                delete: 'srtOriginEntryPointMessage',
                error: 'srtOriginEntryPointMessageError',
                success: 'srtOriginEntryPointMessage',
            },
            text: {
                ...BASE_FORM_MESSAGES,
                FORM_ERROR: renderFormErrorMessages,
            },
        },
        fields: {
            id: {
                component: Form.IdField,
                dataMapKey: 'srtOriginEntryPoint.id',
                props: {
                    hidden: true,
                    label: '',
                    name: 'id',
                },
            },
            name: {
                dataMapKey: 'srtOriginEntryPoint.name',
                props: {
                    component: Form.SemanticInput,
                    label: 'Name',
                    name: 'name',
                    required: true,
                    type: 'input',
                },
            },
            description: {
                dataMapKey: 'srtOriginEntryPoint.description',
                props: {
                    component: Form.SemanticInput,
                    label: 'Description',
                    type: 'input',
                    name: 'description',
                },
            },
            url: {
                dataMapKey: 'srtOriginEntryPoint.url',
                props: {
                    component: Form.SemanticInput,
                    label: 'URL',
                    name: 'url',
                    required: true,
                    type: 'input',
                },
            },
            previewUrl: {
                dataMapKey: 'srtOriginEntryPoint.preview_url',
                props: {
                    component: Form.SemanticInput,
                    label: 'Preview URL',
                    name: 'preview_url',
                    type: 'input',
                    className: '--long-width',
                    allowClear: true,
                },
            },
            closeCaptioning: {
                dataMapKey: 'srtOriginEntryPoint.has_cc',
                props: {
                    component: Form.SemanticInput,
                    label: 'Close Captioning',
                    name: 'has_cc',
                    type: 'toggle',
                },
            },
            adSupport: {
                dataMapKey: 'srtOriginEntryPoint.has_scte35',
                props: {
                    ...adSupportSCTEField('has_scte35'),
                },
            },
            adSpliceConfig: {
                dataMapKey: 'srtOriginEntryPoint.ad_splice_config.id',
                optionsKey: 'adSpliceConfigs',
                props: {
                    ...adSpliceConfigField('ad_splice_config'),
                    component: Form.SemanticSelect,
                },
            },
            tournaments: {
                dataMapKey: 'srtOriginEntryPoint.tournaments',
                props: {
                    allowClear: true,
                    component: Form.SemanticSelect,
                    label: 'Tournaments',
                    minCharacters: 3,
                    multiple: true,
                    name: 'tournaments',
                    placeholder: REQUIRE_THREE_LETTERS_PLACEHOLDER,
                },
            },
            contentCategories: {
                dataMapKey: 'srtOriginEntryPoint.content_categories',
                props: {
                    allowClear: true,
                    component: Form.SemanticSelect,
                    label: 'Content categories',
                    minCharacters: 3,
                    multiple: true,
                    name: 'content_categories',
                    placeholder: REQUIRE_THREE_LETTERS_PLACEHOLDER,
                },
            },
        },
        mutation: {
            createEntity: CreateSrtOriginEntryPoint,
            deleteEntity: DeleteSrtOriginEntryPoint,
            updateEntity: UpdateSrtOriginEntryPoint,
        },
        query: {
            getEntity: GetSrtOriginEntryPointForForm,
            getOptions: GetOptionsForForm,
        },
    };
}
